/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./zenBlocks.vue?vue&type=template&id=461dd141&scoped=true"
import script from "./zenBlocks.vue?vue&type=script&lang=js"
export * from "./zenBlocks.vue?vue&type=script&lang=js"
import style0 from "./zenBlocks.vue?vue&type=style&index=0&id=461dd141&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461dd141",
  null
  
)

export default component.exports